var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordCheckInvalid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88471 6.2068C8.02558 6.07269 8.21303 5.99855 8.40753 6.00002C8.60202 6.00149 8.78833 6.07846 8.92716 6.21469C9.06598 6.35092 9.14645 6.53575 9.15159 6.73018C9.15673 6.92461 9.08614 7.11343 8.95471 7.2568L4.96471 12.2468C4.8961 12.3207 4.81329 12.38 4.72124 12.4212C4.62919 12.4623 4.52978 12.4845 4.42896 12.4864C4.32814 12.4882 4.22798 12.4698 4.13447 12.432C4.04095 12.3943 3.95601 12.3381 3.88471 12.2668L1.23871 9.6208C1.16502 9.55214 1.10592 9.46934 1.06493 9.37734C1.02394 9.28534 1.00189 9.18603 1.00012 9.08533C0.99834 8.98462 1.01686 8.88459 1.05459 8.79121C1.09231 8.69782 1.14845 8.61298 1.21967 8.54176C1.29089 8.47055 1.37572 8.4144 1.46911 8.37668C1.5625 8.33896 1.66253 8.32043 1.76323 8.32221C1.86393 8.32399 1.96325 8.34603 2.05525 8.38702C2.14725 8.42801 2.23005 8.48712 2.29871 8.5608L4.39271 10.6538L7.86571 6.2288L7.88471 6.2068Z",
    fill: "#C00055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordCheckInvalid);
export default __webpack_public_path__ + "static/media/password_check_invalid.12d67e38ecd558a7f95d2f1e69e77640.svg";
export { ForwardRef as ReactComponent };